
import { useState } from "react";
import LottieIcon from "../LottieIcon/LottieIcon";
import { CustomSidebar } from "./Custom-Sidebar";
import OptionsIcon from "../../Images/icons/components/options-icon";

import { Button } from "antd";
import CustomPopover from "../CustomPopover/Custom-popover";

const EmployeeSidebar = ({ title, profiles = [], userId, onSelectProfile, onEditProfile, selectedProfileId, onDownloadPDF, onDownloadWord,onDeleteProfile, }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [visiblePopover, setVisiblePopover] = useState(null);

  const menuItems = profiles.map((profile, index) => {
    const isActive = profile.id === selectedProfileId;
    const isHovered = hoveredItem === profile.id;

    // Popover content for this profile
    const popoverContent = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
         <Button
          onClick={(e) => {
            e.stopPropagation();
            onEditProfile(profile);
            setVisiblePopover(null);        
          }}
          style={{ width: "11rem" }}
          className="navbar-item"
          onMouseEnter={() => setHoveredButton(`edit-${profile.id}`)}
          onMouseLeave={() => setHoveredButton(null)}
        >
          <span>Edit</span>
          <LottieIcon 
            name="editIcon" 
            size={24} 
            shouldPlay={hoveredButton === `edit-${profile.id}`} 
          />
        </Button>


        <Button
          className="navbar-item"
          onClick={(e) => {
            e.stopPropagation();
            // Add your delete handler her
            setVisiblePopover(null);
            onDeleteProfile(profile.id);
          }}
          onMouseEnter={() => setHoveredButton(`delete-${profile.id}`)}
          onMouseLeave={() => setHoveredButton(null)}
          style={{ width: "11rem" }}
        >
          <span>Delete</span>
          <LottieIcon name="trashIcon" size={24} shouldPlay={hoveredButton === `delete-${profile.id}`} />
        </Button>

        <Button
          onClick={(e) => {
            e.stopPropagation();
            onDownloadPDF(profile.id);
            setVisiblePopover(null);
          }}
          className="navbar-item"
          onMouseEnter={() => setHoveredButton(`download-pdf-${profile.id}`)}
          onMouseLeave={() => setHoveredButton(null)}
          style={{ width: "11rem" }}
        >
          <span>Download PDF</span>
             <LottieIcon name="downloadArrow" size={24} shouldPlay={hoveredButton === `download-pdf-${profile.id}`} />
        </Button>
        <Button  onClick={(e) => {
            e.stopPropagation();
            onDownloadWord(profile.id);
            
            setVisiblePopover(null);
          }} className="navbar-item"   onMouseEnter={() => setHoveredButton(`download-word-${profile.id}`)}
          onMouseLeave={() => setHoveredButton(null)}style={{ width: "11rem" }}>
          <span>Download Word</span>
                <LottieIcon name="downloadArrow" size={24} shouldPlay={hoveredButton === `download-word-${profile.id}`} />
        </Button>

        {/* Add more buttons here as needed */}
      </div>
    );

    return {
      id: profile.id || index,
      label: profile.jobTitle,
      isActive,

      menuIcon: (
        <CustomPopover
          content={popoverContent}
          placement="bottomRight"
          trigger="click"
          open={visiblePopover === profile.id}
          onOpenChange={(open) => {
            setVisiblePopover(open ? profile.id : null);
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            onMouseEnter={() => setHoveredItem(profile.id)}
            onMouseLeave={() => setHoveredItem(null)}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            {isActive ? (
              <OptionsIcon color="#FFFFFF" rotate={90} />
            ) : isHovered ? (
              <LottieIcon name="threedotsIcon" size={24} shouldPlay={true} />
            ) : (
              <OptionsIcon color="#464646" rotate={90}/>
            )}
          </div>
        </CustomPopover>
      ),

      onClick: () => onSelectProfile(profile.id),
    };
  });

  return (
    <div>
      <CustomSidebar title={title} menuItems={menuItems} width="100%" activeItem={selectedProfileId} />
    </div>
  );
};

export default EmployeeSidebar;
